import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-332330d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]



export default /*#__PURE__*/_defineComponent({
  props: ['tip', 'offset', 'link', 'icon'],
  setup(__props) {



const lo = location.host

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    placement: "top",
    effect: "light",
    "hide-after": 30,
    offset: 5
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", {
        class: "tip",
        innerHTML: __props.tip
      }, null, 8, _hoisted_1),
      (__props.link)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (__props.link.includes('http'))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: __props.link,
                  target: "_blank"
                }, _toDisplayString(__props.link), 9, _hoisted_3))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: __props.link
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(lo) + __props.link), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (__props.icon)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.icon,
            alt: "",
            class: _normalizeClass(["icon-img help-tooltip-icon", __props.offset || 'ml-5'])
          }, null, 10, _hoisted_4))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["icon", __props.offset || 'ml-5'])
          }, "?", 2))
    ]),
    _: 1
  }))
}
}

})